import Hero from "@/components/sections/Hero";
import TheProblem from "@/components/sections/TheProblem";
import TransformFramework from "@/components/sections/TransformFramework";
import PentaVoiceSummary from "@/components/sections/PentaVoiceSummary";
import DepartmentsSection from "@/components/sections/DepartmentsSection";
import DifferentiatorSection from "@/components/sections/DifferentiatorSection";
import MethodologicallyAnchored from "@/components/sections/MethodologicallyAnchored";
import CTABand from "@/components/sections/CTABand";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <TheProblem />
      <TransformFramework />
      <PentaVoiceSummary />
      <DepartmentsSection />
      <DifferentiatorSection />
      <MethodologicallyAnchored />
      <CTABand />
    </div>
  );
}
